// extracted by css-extract-rspack-plugin
export default {"progressCircle":"IssueItemSubIssuesSummary-module__progressCircle__VN1Lzte","token":"IssueItemSubIssuesSummary-module__token__apyNlnw"};